import { Link } from 'react-router-dom';
import { FormField, FormButton } from './FormField';

export const LoginForm = ({ email, password, errors, touched, isLoading, onEmailChange, onPasswordChange, onEmailBlur, onPasswordBlur, onSubmit }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <form className="flex flex-col gap-6 w-full" onSubmit={handleSubmit} noValidate>
      {/* Email */}
      <FormField
        id="email"
        name="email"
        label="Adresse email"
        type="email"
        value={email}
        onChange={(e) => onEmailChange(e.target.value)}
        onBlur={onEmailBlur}
        error={errors.email}
        touched={touched.email}
        placeholder="admin@example.com"
        required
        autoComplete="email"
      />

      {/* Password */}
      <div className="flex flex-col gap-2">
        <FormField
          id="password"
          name="password"
          label="Mot de passe"
          type="password"
          value={password}
          onChange={(e) => onPasswordChange(e.target.value)}
          onBlur={onPasswordBlur}
          error={errors.password}
          touched={touched.password}
          placeholder="••••••••"
          required
          autoComplete="current-password"
        />
        <Link
          to="/mot-de-passe-oublie"
          className="text-sm font-medium text-teal-600 hover:text-teal-700 transition"
        >
          Mot de passe oublié ?
        </Link>
      </div>

      {/* Submit Button */}
      <FormButton
        type="submit"
        isLoading={isLoading}
        disabled={isLoading}
      >
        Se connecter
      </FormButton>

      {/* Divider */}
      <div className="flex items-center gap-4 my-2">
        <div className="flex-1 h-px bg-gray-200"></div>
        <span className="text-gray-500 text-sm">Nouveau ?</span>
        <div className="flex-1 h-px bg-gray-200"></div>
      </div>

      {/* Register Button */}
      <FormButton
        type="button"
        variant="secondary"
        onClick={() => window.location.href = '/inscription-admin'}
      >
        Créer un compte
      </FormButton>
    </form>
  );
};
